var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPagesQAndA(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M139.9 58.74L133.09 136.59C132.978 137.879 132.359 139.07 131.369 139.903C130.379 140.735 129.099 141.141 127.81 141.03L58.49 135C57.2004 134.886 56.0088 134.264 55.1764 133.273C54.3441 132.281 53.939 131 54.05 129.71L61.93 39.58C62.0469 38.2914 62.6687 37.1014 63.6598 36.2696C64.6508 35.4378 65.9307 35.0317 67.22 35.14L125.02 40.14L139.9 58.74Z",
    fill: "#E9AF34",
    stroke: "#E9AF34",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90.23 26.04L71.51 27.68L69.88 8.95996L90.23 26.04Z",
    fill: "#DB6C2F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.23 26.04L71.51 27.68L69.88 8.95996L90.23 26.04Z",
    stroke: "#DB6C2F",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2201 51.3499L31.1001 50.0599C30.5021 50.3512 29.8536 50.5244 29.1901 50.5699C26.1301 50.8399 24.0201 48.8499 23.7201 45.4199C23.4201 41.9899 25.1501 39.6499 28.2101 39.4199C31.2701 39.1899 33.3901 41.1399 33.6901 44.5699C33.828 45.441 33.7586 46.3322 33.4875 47.1714C33.2165 48.0106 32.7514 48.7741 32.1301 49.3999L33.7401 51.2499L32.2201 51.3499ZM30.2201 49.0499L28.7001 47.3099L30.2201 47.1799L31.2201 48.3599C31.6451 47.8546 31.9547 47.2626 32.1274 46.6253C32.3001 45.988 32.3317 45.3207 32.2201 44.6699C31.9901 41.9999 30.4601 40.4399 28.2201 40.6699C25.9801 40.8999 24.7701 42.6699 25.0001 45.3399C25.2301 48.0099 26.7701 49.5599 29.0001 49.3399C29.4202 49.3128 29.8327 49.2147 30.2201 49.0499Z",
    fill: "#DB6C2F",
    stroke: "#DB6C2F",
    strokeWidth: 0.17,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.26 83.7199L29.96 84.0899L29.14 87.2899L27.72 87.4099L30.77 76.2399L32.1 76.1199L37 86.5999L35.58 86.7199L34.26 83.7199ZM30.26 82.9099L33.77 82.6099L31.6 77.8199L30.26 82.9099Z",
    fill: "#DB6C2F",
    stroke: "#DB6C2F",
    strokeWidth: 0.17,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M87.63 26.25L88.12 31.81",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M81 73.8399L80.11 72.3699C79.4596 72.5502 78.7814 72.6078 78.11 72.5399C75.04 72.2699 73.31 69.9499 73.61 66.5399C73.91 63.1299 76.0199 61.1199 79.0899 61.3799C82.1599 61.6399 83.88 63.9799 83.58 67.3799C83.5674 68.2609 83.346 69.1263 82.934 69.9051C82.522 70.6839 81.9312 71.3538 81.2099 71.8599L82.4899 73.9999L81 73.8399ZM79.4 71.2199L78.2099 69.2199L79.73 69.3499L80.54 70.6899C81.0544 70.2719 81.4713 69.7466 81.7614 69.1507C82.0516 68.5548 82.2081 67.9026 82.22 67.2399C82.45 64.5699 81.22 62.7699 79 62.5799C76.78 62.3899 75.25 63.9399 75 66.5799C74.75 69.2199 76 71.0499 78.22 71.2399C78.6118 71.2966 79.0102 71.2899 79.4 71.2199Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.17,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M77.36 106.06L73.06 105.69L71.7 108.69L70.28 108.56L75.22 98.0898L76.55 98.2098L79.55 109.38L78.13 109.26L77.36 106.06ZM73.56 104.57L77.07 104.88L75.77 99.7898L73.56 104.57Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.17,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M48.62 113.05L20.69 115.45C20.0503 115.506 19.4057 115.436 18.7933 115.242C18.1809 115.049 17.6127 114.737 17.1212 114.323C16.6298 113.91 16.2247 113.403 15.9294 112.833C15.634 112.263 15.4541 111.64 15.4 111L7.52 20.88C7.46388 20.238 7.5355 19.5911 7.73074 18.9769C7.92597 18.3627 8.24094 17.7932 8.65748 17.3013C9.07401 16.8095 9.58384 16.405 10.1575 16.1113C10.7312 15.8176 11.3575 15.6404 12 15.59L69.8 10.54",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M38.88 40.8599L55.47 39.1699",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M39.64 49.5801L54.03 48.0801",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8 59.4698L53.1 56.8398",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M42.04 76.9601L52.49 76.0801",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8 85.67L51.01 84.99",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M28.96 95.57L49.65 93.79",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M142.5 58.9799L123.78 57.3399L125.42 38.6199",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M89.35 64.6599L124.21 67.7099",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M88.59 73.3799L123.45 76.4199",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M73.24 80.72L116.57 84.51",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1899 100.76L121.05 103.81",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4301 109.47L120.29 112.52",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M70.09 116.81L113.41 120.6",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPagesQAndA);
export default __webpack_public_path__ + "static/media/pages_q_and_a.bd27132dc9078b226a00955123ee138b.svg";
export { ForwardRef as ReactComponent };